import { Button, Form, Table } from 'antd';
import styled from 'styled-components';

type BillingActionAlert = 'billing' | 'confirmation';

export const BillingDataContainer = styled.div`
    padding: 20px;
    background-color: ${(props) => props.theme.colors.backgroundColor};
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const BillingSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const BillingSection = styled.section`
    width: 100%;
    background: ${({ theme }) => theme.colors.antdBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    border-radius: 4px;
    padding: 24px;
    flex-wrap: wrap;
`;

export const BillingHeader = styled.div`
    display: flex;
    justify-content: space-between;
    flex: wrap;
    gap: 20px;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.antdBorder};
    margin-bottom: 16px;
    padding-bottom: 12px;
    flex-wrap: wrap;
`;

export const BillingContent = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

export const BillingHeaders = styled.div`
    display: flex;
    flex-direction: column;
`;

export const BillingTitle = styled.h2<{
    $fontSize?: number;
    $fontWeight?: number;
}>`
    font-size: ${(props) => props.$fontSize || 15}px !important;
    font-weight: ${(props) => props.$fontWeight || 600} !important;
    color: ${({ theme }) => theme.colors.font};
    margin: 0px;
`;

export const BillingDescription = styled.p<{
    $fontSize?: number;
    $fontWeight?: number;
    $lineHeight?: string;
}>`
    font-size: ${(props) => props.$fontSize || 13}px;
    color: ${({ theme }) => theme.colors.lightFont} !important;
    ${(props) => props.$fontWeight && `font-weight: ${props.$fontWeight};`}
    margin: 0px !important;
    ${(props) => props.$lineHeight && `line-height: ${props.$lineHeight};`}
`;

export const BillingAction = styled.div`
    display: flex;
    gap: 8px;
`;

export const ButtonStyle = styled(Button)`
    border-radius: 4px;
`;

export const BillingAlert = styled.div<{ type: BillingActionAlert }>`
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 10px 14px;
    background: ${(props) =>
        props.theme.theme === 'dark'
            ? props.type === 'billing'
                ? '#d4880626'
                : '#1890ff1f'
            : props.type === 'billing'
            ? '#fffbe6'
            : 'rgb(230, 247, 255)'};
    border: ${(props) =>
        props.theme.theme === 'dark'
            ? props.type === 'billing'
                ? '1px solid #d4880659'
                : '1px solid #1890ff59'
            : props.type === 'billing'
            ? '1px solid #ffe58f'
            : '1px solid rgb(145, 202, 255)'};
    border-radius: 4px;
`;

export const BillingAlertIcon = styled.div<{ type: BillingActionAlert }>`
    color: ${(props) =>
        props.type === 'billing' ? '#d48806' : 'rgb(0, 112, 244)'};
    font-weight: 700;
    font-size: 14px;
    flex-shrink: 0;
    line-height: 20px;
    width: 16px;
    text-align: center;
`;

export const BillingAlertContent = styled.div<{ direction?: 'row' | 'column' }>`
    display: flex;
    flex-direction: ${(props) => props.direction || 'column'};
    align-items: ${(props) =>
        props.direction === 'row' ? 'center' : 'flex-start'};
`;

export const RulesBillingFilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
`;

export const RulesBillingFormContainer = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

export const RulesBilingStoreInfoArea = styled.div`
    display: flex;
    margin-top: 5px;
    text-wrap: wrap;
`;

export const TableStyled = styled(Table)`
    .ant-table-thead > tr > th {
        font-weight: 500;
        color: ${({ theme }) => theme.colors.font};
        font-size: 13px;
    }

    .ant-table-thead
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(
            .ant-table-row-expand-icon-cell
        ):not([colspan])::before {
        content: none;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.font};
    }
`;

export const BadgeTypeBilling = styled.div`
    display: inline-block;
    padding: 1px 8px;
    font-size: 12px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.lightFont}1a;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const BillingLinking = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
    font-style: italic;
`;

export const FormItemStyled = styled(Form.Item)`
    .ant-form-item-label > label {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.font};
        padding: 0 0 2px;
    }

    .ant-col.ant-form-item-label {
        padding: 0px !important;
    }

    .ant-col .ant-form-item-label {
        padding: 0 0 2px;
    }

    .ant-form-item-extra {
        font-size: 11px;
        color: #767676;
    }
    .ant-form-item-explain-error {
        font-size: 12px;
    }

    .ant-row.ant-form-item-row {
        margin: 0px !important;
    }
`;

export const FormStyled = styled(Form)`
    .ant-form-item-label > label {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.font};
        padding: 0 0 2px;
    }

    .ant-col .ant-form-item-label {
        padding: 0 0 2px;
    }

    .ant-form-item-extra {
        font-size: 11px;
        color: #767676;
    }
    .ant-form-item-explain-error {
        font-size: 12px;
    }
`;
